fragment NewsletterSignupFormFragment on newsletterSignupForm_Entry {
  typeHandle
  headline
  teaser
  description
  legalText
  buttonText
  layout
  theme
  textAlign
  image {
    url
    title
  }
  imagePosition
  mailchimpListId
  mailchimpTags
  newsletterBackend
}
